// src/context/AuthContext.js
import React, { createContext, useContext } from 'react';

// Define the shape of the authentication context value.
// This helps in understanding what the context provides.
// It's also useful for TypeScript, but good practice in JS too.
const AuthContext = createContext({
    // State variables
    isAuthenticated: false, // Is the user currently logged in?
    user: null, // Object containing user details (userId, organizationId, role, etc.)
    token: null, // The JWT received from the backend
    isLoadingAuth: true, // Is the authentication state currently being loaded (e.g., from localStorage)?

    // Functions to interact with the auth state
    // login: async (credentials: { identifier, password, organizationIdentifier }) => void
    login: async () => {}, // Placeholder function for login
    // logout: () => void
    logout: () => {}, // Placeholder function for logout
    // setUser: (userData) => void // Optional: if you need to update user data after initial login
});

// Custom hook to easily access the authentication context.
// This hook should be used by components that need access to auth state or functions.
export const useAuth = () => {
    const context = useContext(AuthContext);
    if (context === undefined) {
        // This error helps ensure the hook is used within an AuthProvider.
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};

export default AuthContext;
